module.exports = __webpack_public_path__ + "media/images/sp/calendar/active-9420118bb1193c527225eaf10af34965.svg";